import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { Switch as MuiSwitch } from '@mui/material';

import useStyles from '@/designSystem/Form/Toggle/styles';

type Props = {
  isChecked: boolean;
  isDisabled?: boolean;
  inputProps?: { 'aria-label': string };
  name?: string;
  isSmall?: boolean;
};

export const Toggle: FC<
  PropsWithChildren<Props & HTMLAttributes<HTMLInputElement>>
> = ({
  isChecked = false,
  isDisabled = false,
  name = '',
  inputProps = { 'aria-label': '' },
  isSmall = false,
  onChange,
}) => {
  const { classes } = useStyles({ isSmall });

  return (
    <MuiSwitch
      checked={isChecked}
      disabled={isDisabled}
      onChange={onChange}
      color="primary"
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      name={name}
      title={inputProps['aria-label']}
    />
  );
};
